import { initializeVueApp } from './init.js';

initializeVueApp();
